
import React from 'react';
import { Helmet } from 'react-helmet-async';

const FAQPage = () => {
    const faqs = [
      {
        question: "What materials do you use for your products?",
        answer: "We primarily use various copper alloys including Phosphorous Bronze, Aluminium Bronze, Gun Metal, and Brass for our products."
      },
      {
        question: "Do you offer custom manufacturing services?",
        answer: "Yes, we offer custom manufacturing services tailored to our clients' specific requirements. Please contact us with your project details for more information."
      },
      {
        question: "What industries do you serve?",
        answer: "We serve a wide range of industries including automotive, engineering, marine, and industrial machinery sectors."
      },
      {
        question: "What quality standards do you adhere to?",
        answer: "We are an ISO 9001 certified company and adhere to strict quality management systems to ensure the highest standards in our products."
      },
      {
        question: "Do you ship internationally?",
        answer: "Yes, we do ship our products internationally. Please contact our sales team for specific shipping information and costs."
      }
    ];
  
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": { "@type": "Answer", "text": faq.answer }
      }))
    };

    return (
      <>
        <Helmet>
          <title>FAQ – Bronze Bushings & Precision Manufacturing | Mato Industries</title>
          <meta name="description" content="Answers to common questions about Mato Industries: materials, custom manufacturing, quality certifications, international shipping, CNC machining services." />
          <link rel="canonical" href="https://www.matoindustries.com/faq" />
          <meta property="og:url" content="https://www.matoindustries.com/faq" />
          <meta property="og:title" content="FAQ – Bronze Bushings & Precision Manufacturing | Mato Industries" />
          <meta property="og:description" content="Answers to common questions about Mato Industries: materials, custom manufacturing, quality certifications, international shipping, CNC machining services." />
          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>
        <div className="container mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold mb-6">Frequently Asked Questions</h1>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b pb-4">
                <h2 className="text-xl font-semibold mb-2">{faq.question}</h2>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };
  
export default FAQPage;